export default ({ colors, textDecorations }) => ({
  link: {
    marginBottom: '0',
    color: colors.link.text.default,
    textDecoration: textDecorations.link.default,
    ':hover': {
      color: colors.link.text.hover,
      textDecoration: textDecorations.link.hover
    }
  }
})



// WEBPACK FOOTER //
// ./components/link/styles.js